/**
 * <tray-finish-picker> sofa scoping for the V2 PDP.
 *
 * The dedicated Tray Finish picker (snippets/tray-finish-picker-v2.liquid) uses
 * the shared data-v2-option-input contract, so variant selection is owned by
 * assets/component-configuration-picker-v2.js. This file only handles SOFA
 * SCOPING: a finish can be offered on only some sofas (e.g. Eclipse trunks are
 * Charred Ash only). Each swatch carries `data-tf-sofa` (space-joined handles of
 * the sofas that offer it); on every `variant:change` we hide swatches whose
 * list excludes the currently-selected sofa, and — if the checked finish just
 * became unavailable — select the first still-visible one (its `change` bubbles
 * to the config picker, which resolves the variant).
 */
(function () {
  if (window.__v2TrayFinishBound) return;
  window.__v2TrayFinishBound = true;

  function handleize(s) {
    return String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function inList(list, val) {
    if (!list) return true;
    return (' ' + list.trim() + ' ').indexOf(' ' + val + ' ') !== -1;
  }

  function scope(root, sofaHandle) {
    var firstVisible = null;
    var checkedHidden = false;
    root.querySelectorAll('.tf-v2__swatch').forEach(function (sw) {
      var ok = !sofaHandle || inList(sw.getAttribute('data-tf-sofa'), sofaHandle);
      sw.hidden = !ok;
      var input = sw.querySelector('.tf-v2__input');
      if (ok && !firstVisible) firstVisible = input;
      if (input && input.checked && !ok) checkedHidden = true;
    });
    if (checkedHidden && firstVisible) {
      firstVisible.checked = true;
      firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function sofaFromEvent(root, variant) {
    var pos = parseInt(root.getAttribute('data-tf-sofa-position'), 10) || 0;
    if (pos && variant && variant['option' + pos]) return handleize(variant['option' + pos]);
    return root.__tfSofa || '';
  }

  function apply(variant) {
    document.querySelectorAll('[data-tray-finish-picker]').forEach(function (root) {
      root.__tfSofa = sofaFromEvent(root, variant);
      scope(root, root.__tfSofa);
    });
  }

  document.addEventListener('variant:change', function (e) {
    apply(e && e.detail && e.detail.variant);
  });

  // Initial scope: read the currently-checked sofa radio (config picker markup).
  function init() {
    document.querySelectorAll('[data-tray-finish-picker]').forEach(function (root) {
      var pos = parseInt(root.getAttribute('data-tf-sofa-position'), 10) || 0;
      var sofaInput = pos
        ? document.querySelector('[data-v2-option-input][data-option-position="' + pos + '"]:checked')
        : null;
      if (sofaInput && sofaInput.getAttribute('data-option-value')) {
        root.__tfSofa = handleize(sofaInput.getAttribute('data-option-value'));
      }
      scope(root, root.__tfSofa || '');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
